import { render, staticRenderFns } from "./CInvoiceTotal.vue?vue&type=template&id=ee637bf4&scoped=true"
import script from "./CInvoiceTotal.vue?vue&type=script&lang=ts"
export * from "./CInvoiceTotal.vue?vue&type=script&lang=ts"
import style0 from "./CInvoiceTotal.vue?vue&type=style&index=0&id=ee637bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee637bf4",
  null
  
)

export default component.exports